"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const ConnectingLines = ({ onScore }) => {
  const [connections, setConnections] = useState({})
  const [currentTask] = useState(0)

  const tasks = [
    {
      items: [
        { id: "flower", emoji: "🌸", count: 1 },
        { id: "penguins", emoji: "🐧", count: 6 },
        { id: "empty", emoji: "", count: 0 },
        { id: "octopus", emoji: "🐙", count: 5 },
        { id: "dolphins", emoji: "🐬", count: 8 },
      ],
      numbers: [5, 8, 1, 6, 0],
      correctConnections: {
        flower: "1",
        penguins: "6",
        empty: "0",
        octopus: "5",
        dolphins: "8",
      },
    },
  ]

  const current = tasks[currentTask]

  const makeConnection = (itemId, number) => {
    const newConnections = { ...connections, [itemId]: number }
    setConnections(newConnections)

    if (current.correctConnections[itemId] === number) {
      onScore(10)
    }
  }

  return (
    <div className="lesson-card card-indigo">
      <h2 className="lesson-title" style={{ color: "#3730a3" }}>
        Соединяем линиями 🔗
      </h2>

      <p style={{ fontSize: "1.25rem", textAlign: "center", marginBottom: "24px" }}>
        Соедини предметы с правильными числами!
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "32px", marginBottom: "24px" }}>
        {/* Левая колонка - предметы */}
        <div>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", textAlign: "center", marginBottom: "16px" }}>
            Предметы
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {current.items.map((item) => (
              <div
                key={item.id}
                style={{
                  backgroundColor: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "2px solid #e5e7eb",
                  textAlign: "center",
                }}
              >
                {item.count > 0 ? (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "4px" }}>
                    {Array.from({ length: Math.min(item.count, 9) }, (_, i) => (
                      <div key={i} style={{ fontSize: "1.5rem" }}>
                        {item.emoji}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ fontSize: "2.5rem", color: "#d1d5db" }}>∅</div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Средняя колонка - числа */}
        <div>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", textAlign: "center", marginBottom: "16px" }}>Числа</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {current.numbers.map((number, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#fef3c7",
                  padding: "16px",
                  borderRadius: "50%",
                  textAlign: "center",
                  border: "2px solid #f59e0b",
                }}
              >
                <div style={{ fontSize: "1.875rem", fontWeight: "bold" }}>{number}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Правая колонка - абакусы */}
        <div>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", textAlign: "center", marginBottom: "16px" }}>
            Абакус
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {current.numbers.map((number, index) => (
              <div key={index} style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ transform: "scale(0.7)" }}>
                  <AbacusDisplay value={number} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: "1.125rem", marginBottom: "16px" }}>Выберите предмет, затем число:</p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "16px",
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          {current.items.map((item) => (
            <div key={item.id} style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <div style={{ fontSize: "0.875rem", fontWeight: "bold" }}>{item.id}</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "4px" }}>
                {current.numbers.map((number) => (
                  <button
                    key={`${item.id}-${number}`}
                    onClick={() => makeConnection(item.id, number.toString())}
                    style={{
                      fontSize: "0.875rem",
                      padding: "8px",
                      border: "2px solid",
                      borderRadius: "4px",
                      backgroundColor: connections[item.id] === number.toString() ? "#22c55e" : "white",
                      color: connections[item.id] === number.toString() ? "white" : "#374151",
                      borderColor: connections[item.id] === number.toString() ? "#16a34a" : "#e5e7eb",
                      cursor: "pointer",
                    }}
                  >
                    {number}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ConnectingLines
